import { createSlice } from '@reduxjs/toolkit';
import { initialEdges, initialNodes } from '../utils/data';

export const vanshReducer = createSlice({
  name: 'vansh',
  initialState: {
    vanshNodes: initialNodes,
    vanshEdges: initialEdges,
    height: 200,
  },
  reducers: {
    editNode: (state, action) => {
      state.vanshNodes = action.payload;
    },
    editEdge: (state, action) => {
      state.vanshEdges = action.payload;
    },
    editNodeValue: (state, action) => {
      const updatedValue = state.vanshNodes.map(el => {
        if (el.id === action.payload.id) {
          return { ...el, data: { value: action.payload.value } };
        }
        return el;
      });

      state.vanshNodes = updatedValue;
    },
    updateHeight: (state, action) => {
      state.height = action.payload;
    },
  },
});

export default vanshReducer.reducer;
export const { editNode, editEdge, editNodeValue, updateHeight } =
  vanshReducer.actions;
